var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoopBackAuth } from '@careapp/angular-sdk';
import { DeveloperFunction } from '@devmod/core';
import { Store } from '@ngrx/store';
import { production } from '../../environments/environment';
import * as actions from '../store/actions/auth.actions';
import * as selectors from '../store/reducers';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(auth, route, store) {
        this.auth = auth;
        this.route = route;
        this.store = store;
        this.attempts = 0;
        this.error = this.store.select(selectors.auth.getError);
        this.loading = this.store.select(selectors.auth.getLoading);
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.jwt = params.jwt;
            _this.organisationId = params.organisationId;
        });
    };
    LoginComponent.prototype.login = function (payload) {
        this.store.dispatch(new actions.RequestAuthLoginAction(payload));
    };
    __decorate([
        DeveloperFunction(production
            ? []
            : [
                {
                    label: 'Login as Coordinator',
                    args: [
                        {
                            email: 'COORDINATOR@example.com',
                            password: 'development'
                        }
                    ]
                },
                {
                    label: 'Login as Org Admin',
                    args: [
                        {
                            email: 'ORG_ADMIN@example.com',
                            password: 'development'
                        }
                    ]
                },
                {
                    label: 'Login as Super Admin',
                    args: [
                        {
                            email: 'aaaaaaaa-0000-0000-0000-000000000000@example.com',
                            password: 'development'
                        }
                    ]
                }
            ]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], LoginComponent.prototype, "login", null);
    return LoginComponent;
}());
export { LoginComponent };
